/*
 *  Campaign__Create_LocationSelector.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React, { Component } from "react";
import { Circle, GoogleMap, Marker } from "@react-google-maps/api";
import logger from "../../../utils/LoggerFrontend";

//------------------------------------------------------------------------------
// Interal dep.
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Config
//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
// Components
//------------------------------------------------------------------------------

//map dimensions
const containerStyle = {
  height: "400px"
};

//default center is Germany's center
const DEFAULT_CENTER = {
  lat: 51.1657,
  lng: 10.4515
};

class MapComponent extends Component {
  render() {
    const options = {
      strokeColor: "#ff0000",
      strokeOpacity: 0.5,
      strokeWeight: 1,
      fillColor: "#FF0000",
      fillOpacity: 0.1
    };

    const { locations } = this.props;

    logger.log("MapComponent:return", "selected locations", locations);
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={{
          lat: locations.length > 0 ? locations[locations.length - 1].lat : DEFAULT_CENTER.lat,
          lng: locations.length > 0 ? locations[locations.length - 1].lng : DEFAULT_CENTER.lng
        }}
        zoom={5}
      >
        {locations.map((elem, index) => {
          return (
            //Markers and Circles at selected locations
            <div key={index} className="location-select__marker-circle">
              <Marker position={{ lat: elem.lat, lng: elem.lng }} key={index} />
              <Circle
                center={{
                  lat: elem.lat,
                  lng: elem.lng
                }}
                radius={locations[index].radius * 1000}
                options={options}
              />
            </div>
          );
        })}
      </GoogleMap>
    );
  }
}

export default MapComponent;
